<template>
  <v-container>
    <h1>{{ $t(`message.slideTenTitle`) }}</h1>
    <v-row>
      <v-col cols="12">
        <p style="font-size: x-large">
          {{ $t(`message.slideTenSubTitle`) }}
        </p>
      </v-col>
      <v-col cols="12">
        <p style="font-size: large">
          {{ $t(`message.slideTenSliderDetails`) }}
        </p>
      </v-col>
      <v-col cols="12">
        {{ $t(`message.slideTenCriteriaDetails`) }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn
          class="white--text"
          color="#015594"
          @click="toggleCriteria = true"
        >
          {{ $t(`message.CriteriaBtn`) }}
        </v-btn>
      </v-col>
    </v-row>

    <v-divider></v-divider><br />
    <div v-for="item in items" :key="item.name">
      <v-row align="center">
        <v-col>
          <h3>{{ $t(`message.slideTen${item.name}`) }}</h3>
          <br />
          <v-slider
            v-model="item.rating"
            :tick-labels="sliderLabels"
            :max="4"
            step="1"
            ticks="always"
            tick-size="5"
          >
          </v-slider>
        </v-col>
      </v-row>
      <v-divider></v-divider><br />
    </div>
    <v-dialog v-model="toggleCriteria">
      <div class="text-right" style="background: antiquewhite;">
        <v-btn class="text-right" @click="toggleCriteria = false">X</v-btn>
      </div>
      <v-card style="padding: 2.5%">
        <h1>{{ $t(`message.CriteriaDialogTitle`) }}</h1>
        <br />
        <FourteenCriteria />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import FourteenCriteria from "@/components/FourteenCriteria.vue";

export default {
  props: {
    file: { type: String },
    slideNumber: { type: Number },
    updateFile: { type: Function }
  },
  components: {
    FourteenCriteria
  },
  mounted() {
    this.newSlideNumber = this.slideNumber;
    this.audio = new Audio(this.file);
    this.audio.play();
  },
  data() {
    return {
      items: [
        {
          name: "ImproveSafety",
          rating: 0
        },
        {
          name: "ImproveSecurity",
          rating: 0
        },
        {
          name: "ProtectEnvironment",
          rating: 0
        },
        {
          name: "ReduceCongestion",
          rating: 0
        },
        {
          name: "PromoteEfficiency",
          rating: 0
        },
        {
          name: "EconomicGoals",
          rating: 0
        },
        {
          name: "LandGoals",
          rating: 0
        },
        {
          name: "IncreaseConnection",
          rating: 0
        },
        {
          name: "ImproveAccess",
          rating: 0
        },
        {
          name: "ConnectTravel",
          rating: 0
        },
        {
          name: "ConserveEnergy",
          rating: 0
        },
        {
          name: "ImproveQOL",
          rating: 0
        },
        {
          name: "ModalOptions",
          rating: 0
        },
        {
          name: "PreserveROW",
          rating: 0
        }
      ],
      sliderLabels: ["1", "2", "3", "4", "5"],
      audio: null,
      toggleCriteria: false,
      newSlideNumber: null
    };
  },
  watch: {
    items: {
      handler() {
        this.addResponse();
      },
      deep: true
    },
    "$i18n.locale": function() {
      if (this.newSlideNumber === 9) {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.updateFile(9);
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    },
    slideNumber(current) {
      this.newSlideNumber = current;
      if (current !== 9) {
        this.audio.pause();
        this.audio.currentTime = 0;
      } else {
        this.audio = new Audio(this.file);
        this.audio.play();
      }
    }
  },
  methods: {
    ...mapActions({
      addTransporationPriority: "response/addTransporationPriority"
    }),
    addResponse() {
      for (const item of this.items) {
        const name = item.name;
        const rating = item.rating;
        const payload = {
          [name]: parseInt(rating) + 1
        };
        this.addTransporationPriority(payload);
      }
    }
  }
};
</script>

<style scoped>
.list {
  position: relative;
  z-index: 0;
  background-color: #f3f3f3;
  border: 1px solid #efefef;
  border-radius: 3px;
  outline: none;
}
.list-item {
  display: block;
  align-items: center;
  text-align: center;
  width: 100%;
  padding: 10px 20px;
  background-color: #fff;
  border: 3px solid #efefef;
  box-sizing: border-box;
  user-select: none;
  color: #333;
  font-weight: 400;
}
</style>
